const tutorialsHeroSection = $('#hero-section');

const addDashboardHeroIn = () => {
  const animationConfig = {
    offsetPercent: '150',
    opacityStart: 0.9,
    blurStart: '5px',
    duration: 0.9,
    delay: 0,
    stagger: 0.15,
    isDurationCommon: false,
  }

  const heroDescription = tutorialsHeroSection.find('.hero-section-descriptor');
  const heroTitle = tutorialsHeroSection.find('.hero-section-title');
  const heroNavCircles = tutorialsHeroSection.find('.hero-section-nav-circle');
  /*
  const heroVideo = tutorialsHeroSection.find('.hero-video-preview-parent');
  */
  const heroDescriptorCard = tutorialsHeroSection.find('.descriptor-card');
  const heroBtn = tutorialsHeroSection.find('.button-parent');
  const scrollHandler = tutorialsHeroSection.find('.scroll-handle');

  const heroTL = gsap.timeline({
    paused: true, 
    onComplete: () => {
      $(window).trigger('heroReady');
    }, });

  heroTL.addLabel('step1');
  heroTL.add(addTitleAnimation({element: heroTitle, animationConfig: animationConfig}).play(), 'step1+=0.5');
  heroTL.add(elementInAnimationYWOpacity(heroNavCircles.eq(0), '130%', 0, 1, 1.33, 0.67, 0.4).play(), 'step1+=0.6');
  heroTL.add(elementInAnimationYWOpacity(heroNavCircles.eq(1), '150%', 0, 1, 1.33, 0.77, 0.3).play(), 'step1+=0.7');
  heroTL.add(gsap.fromTo(heroNavCircles, {
    scale: 0.83,
  }, {
    scale: 1,
    duration: 0.83,
    ease: pageInEasing, 
  }), 'step1+=1.81');
  heroTL.add(elementInAnimationYWOpacity(heroNavCircles.eq(1), '150%', 0, 1, 1.33, 0.77, 0.3).play(), 'step1+=0.7');
  heroTL.add(elementInAnimationYWOpacity(heroDescription, '1000%', 0, 1, 0.9, 0.9, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.5');
  heroTL.add(elementInAnimationYWOpacity(scrollHandler, '200%', 0, 1, 0.667, 0.667, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.95');
  heroTL.add(addDescriptorCardAnimation(heroDescriptorCard, '100%', 0.667, 0).play(), 'step1+=0.83');
  heroTL.add(addBtnAnimation(heroBtn).play(), 'step1+=1.33');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), 'step1+=2.33');

  return heroTL;
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  const dashboardHeroTL = addDashboardHeroIn();
  pageIn(dashboardHeroTL, nav);
});
